import { Pipe, PipeTransform } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
  name: 'uiAdaptionValue',
  pure: false
})
export class UiAdaptionValuePipe implements PipeTransform {
  constructor(private dataService: DataShareService) {}

  transform(anchorName: string): string {
    const adaption = this.dataService.uiAdaptions.find((x) => x.anchor === anchorName);
    if (!adaption) {
      return '';
    }
    return adaption.value;
  }
}

@Pipe({
  name: 'uiAdaptionVisible',
  pure: false
})
export class UiAdaptionVisiblePipe implements PipeTransform {
  constructor(private dataService: DataShareService) {}

  transform(anchorName: string, showIfNoneExists: boolean = false): boolean {
    const adaption = this.dataService.uiAdaptions.find((x) => x.anchor === anchorName);
    if (!adaption || adaption.visibility === null || adaption.visibility === undefined) {
      return showIfNoneExists;
    }
    const visibility = adaption.visibility.trim();
    return visibility === 'true' || visibility === 'show';
  }
}
@Pipe({
  name: 'uiAdaptionVisible$',
  pure: false
})
export class UiAdaptionVisibleAsyncPipe implements PipeTransform {
  constructor(private dataService: DataShareService) {}

  transform(anchorName: string, showIfNoneExists: boolean = false): Observable<boolean> {
    return this.dataService.uiAdaptions$.pipe(
      map((adaptions) => {
        const adaption = adaptions.find((x) => x.anchor === anchorName);
        if (!adaption || adaption.visibility === null || adaption.visibility === undefined) {
          return showIfNoneExists;
        }
        const visibility = adaption.visibility.trim();
        return visibility === 'true' || visibility === 'show';
      }),
      shareReplay(1)
    );
  }
}

@Pipe({
  name: 'uiCheckIfValues',
  pure: false
})
export class UiCheckIfValuesPipe implements PipeTransform {
  constructor(private dataService: DataShareService) {}

  transform(values: string[]): boolean {
    if (!values) {
      return false;
    }
    if (values.length == 0) {
      return false;
    }
    for (const value of values) {
      const adaption = this.dataService.uiAdaptions.find((x) => x.anchor == value);
      return !!adaption;
    }
  }
}
